import { render, staticRenderFns } from "./AnimalHistory.vue?vue&type=template&id=36f0d636"
import script from "./AnimalHistory.vue?vue&type=script&lang=ts"
export * from "./AnimalHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports